import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

export interface DateFilterModule {
	name: string;
	defaultDateFilter: string;
	columnKey: string;
}

interface DateFilterState {
	modules: DateFilterModule[];
	setDateFilters: (modules: DateFilterModule[]) => void;
	getFilterByModule: (moduleName: string) => DateFilterModule | undefined;
	reset: () => void;
}

export const useDateFilterStore = create<DateFilterState>()(
	devtools(
		persist(
			(set, get) => ({
				modules: [],
				setDateFilters: (modules) =>
					set({ modules }, false, 'dateFilter/set'),
				getFilterByModule: (moduleName) =>
					get().modules.find((m) => m.name === moduleName),
				reset: () => set({ modules: [] }, false, 'dateFilter/reset'),
			}),
			{ name: 'date-filter-store' },
		),
		{ name: 'DateFilterStore' },
	),
);

